import EMPLOYER_GUARD from '@/core/guards/employer.guard';
import ROLE_GUARD from '@/core/guards/role.guard';
import ADDON_GUARD from '@/core/guards/addon.guard';
import { AddonKeys } from '@/core/models/addons.interface';
import { RoleKey } from '@nxtpeople/nxt-vue-library';
import { RouteRecordRaw } from 'vue-router';
import FOLLOW_UP_OVERVIEW_GUARD from './guards/follow-up-overview.guard';
import FollowUpOverview from './pages/FollowUpOverview.vue';

const followUpRoutes: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'FollowUpOverview',
      component: FollowUpOverview,
      beforeEnter: [FOLLOW_UP_OVERVIEW_GUARD, EMPLOYER_GUARD],
   },
   {
      path: 'imw',
      name: 'ImwFollowUpOverview',
      component: () => import('./pages/ImwFollowUpOverview.vue'),
      beforeEnter: [EMPLOYER_GUARD, ROLE_GUARD(RoleKey.TenantAdmin), ADDON_GUARD(AddonKeys.Imw)],
      meta: { titleKey: 'imw.title' },
   },
];

export default followUpRoutes;
